import { reactive } from 'vue'
import { createAiAssistantStore } from './methods/ai-assistant'
import { createColumnMenuStore } from './methods/column-menu'
import { createContextMenuStore } from './methods/row-context-menu'
import { resolveInfiniteScroll } from './utils/infinite-scroll'
import type { GridInternalData, GridOptions, GridReactData } from './types'

export function createInternalData(): GridInternalData {
  return {
    titleList: [],
    visibleColumns: [],
    allColumns: [],
    sortMap: {},
    totalCheckboxMaps: {},
    curCheckboxMaps: {},
    rowDomMaps: {},
    baselineColumns: [],
  }
}

export function createReactData(options: GridOptions): GridReactData {
  const infinite = resolveInfiniteScroll(options)
  return reactive<GridReactData>({
    currentPage: options.params?.currentPage ?? 1,
    pageSize:
      options.params?.pageSize
      ?? (infinite.enabled ? infinite.pageSize : 10),
    pageSizes: (options.params?.pageSizes as number[]) ?? [10, 30, 50, 100],
    total: 0,
    tableData: [],
    currentRow: null,
    editStr: '',
    loading: false,
    loadingMore: false,
    loadError: false,
    loadErrorMsg: '',
    searchKeyword: '',
    filterVisible: false,
    filterGroups: [],
    editStore: {
      actived: {
        row: null,
        field: null,
      },
    },
    footerTableData: [],
    isAllSelected: false,
    isIndeterminate: false,
    checkboxRecordsCount: 0,
    updateCheckboxFlag: 0,
    initStore: {
      export: false,
      custom: false,
      columnMenu: false,
      contextMenu: false,
      aiAssistant: false,
    },
    columnMenuStore: createColumnMenuStore(),
    contextMenuStore: createContextMenuStore(),
    exportStore: {
      visible: false,
      columns: [],
      modeList: [],
      typeList: [],
      isPrint: false,
      hasFooter: false,
      hasMerge: false,
      hasTree: false,
      hasColgroup: false,
    },
    exportParams: {
      filename: '',
      sheetName: '',
      mode: 'current',
      type: 'csv',
      isHeader: true,
      isFooter: false,
    },
    customStore: {
      open: false,
      keyword: '',
      columns: [],
      highlightColumnId: null,
      snapshot: [],
    },
    aiAssistantStore: createAiAssistantStore(),
    validErrorMaps: {},
  })
}
